export default (str) => str.replace(/([-_]\w)/g, (chr) => chr[1].toUpperCase());
